import Box from '@ahamove/web-components/lib/Box';
import ListItem from '@ahamove/web-components/lib/ListItem';
import Stack from '@ahamove/web-components/lib/Stack';
import Typography from '@ahamove/web-components/lib/Typography';
import Image from 'next/legacy/image';
import { useTranslation } from 'next-i18next';
import { homeConfig } from '@/modules/home/homeConfig';

export default function ErrorCity() {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <ListItem>
      <Stack
        direction="column"
        alignItems="center"
        px={2.5}
        py={5}
        width="100%"
        data-test-id="errorCity"
      >
        <Box
          sx={{
            width: 133,
            height: 73,
            mx: 'auto',
            position: 'relative',
          }}
        >
          <Image
            src={'/static/icons/ErrorLoadCity.svg'}
            alt="empty-location"
            layout="fill"
            objectFit="contain"
          />
        </Box>
        <Typography
          variant="h4"
          color="grey.800"
          align="center"
          mt={2}
          maxWidth={230}
        >
          {t('booking:location.error_city_title')}
        </Typography>
        <Typography
          variant="caption"
          color="grey.600"
          align="center"
          fontWeight={500}
          mt={0.75}
        >
          {t('booking:location.error_city_description')}
        </Typography>
      </Stack>
    </ListItem>
  );
}
